import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import socketIOClient from 'socket.io-client'

// Limit retries so a misrouted /ws (502 from CDN) does not poll forever.
const socket = socketIOClient('/', {
  path: '/ws',
  reconnectionAttempts: 3,
  reconnectionDelay: 5000,
  reconnectionDelayMax: 10000,
  timeout: 20000,
})

export const SocketContext = React.createContext(false)

export const SocketProvider = ({ children }) => {
  const contextValue = useMemo(() => ({ socket }), [])

  return (
    <SocketContext.Provider
      value={contextValue}
    >
      {children}
    </SocketContext.Provider>
  )
}

SocketProvider.propTypes = {
  children: PropTypes.node.isRequired
}
